import { useMemo } from "react";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { IntentProject } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableCellText from "ds/components/Table/Row/CellText";

import useCellCopyAction from "../useCellCopyAction";

const IntentProjectsTableCreatedByCell = ({
  item: intentProject,
  ...cellProps
}: TableSimpleCellProps<IntentProject>) => {
  const isEmpty = !intentProject.createdBy;

  const copyAction = useCellCopyAction({
    text: intentProject.createdBy || "",
  });

  const actions = useMemo(() => (isEmpty ? undefined : [copyAction]), [copyAction, isEmpty]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      {isEmpty && <TableCellEmpty />}
      {!isEmpty && <TableCellText>{intentProject.createdBy}</TableCellText>}
    </TableSimpleCell>
  );
};

export default IntentProjectsTableCreatedByCell;
